export default __webpack_public_path__ + "static/media/gallery_07.872bfd8e.jpg";